import '@aileron/divider';
import { registerComponent } from '@aileron/grid';
import { registerComponent as registerComponent$1 } from '@aileron/icon';
import { registerComponent as registerComponent$2 } from '@aileron/link';
import { css, LitElement, html } from 'lit';
import { property, customElement } from 'lit/decorators.js';

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

var axios$3 = {exports: {}};

var axios$2 = {exports: {}};

var bind$2 = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};

var bind$1 = bind$2;

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */
function isPlainObject(val) {
  if (toString.call(val) !== '[object Object]') {
    return false;
  }

  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind$1(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */
function stripBOM(content) {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

var utils$9 = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isPlainObject: isPlainObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim,
  stripBOM: stripBOM
};

var utils$8 = utils$9;

function encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
var buildURL$1 = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils$8.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils$8.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils$8.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils$8.forEach(val, function parseValue(v) {
        if (utils$8.isDate(v)) {
          v = v.toISOString();
        } else if (utils$8.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};

var utils$7 = utils$9;

function InterceptorManager$1() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager$1.prototype.use = function use(fulfilled, rejected, options) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected,
    synchronous: options ? options.synchronous : false,
    runWhen: options ? options.runWhen : null
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager$1.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager$1.prototype.forEach = function forEach(fn) {
  utils$7.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

var InterceptorManager_1 = InterceptorManager$1;

var utils$6 = utils$9;

var normalizeHeaderName$1 = function normalizeHeaderName(headers, normalizedName) {
  utils$6.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};

/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
var enhanceError$1 = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};

var createError;
var hasRequiredCreateError;

function requireCreateError () {
	if (hasRequiredCreateError) return createError;
	hasRequiredCreateError = 1;

	var enhanceError = enhanceError$1;

	/**
	 * Create an Error with the specified message, config, error code, request and response.
	 *
	 * @param {string} message The error message.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The created error.
	 */
	createError = function createError(message, config, code, request, response) {
	  var error = new Error(message);
	  return enhanceError(error, config, code, request, response);
	};
	return createError;
}

var settle;
var hasRequiredSettle;

function requireSettle () {
	if (hasRequiredSettle) return settle;
	hasRequiredSettle = 1;

	var createError = requireCreateError();

	/**
	 * Resolve or reject a Promise based on response status.
	 *
	 * @param {Function} resolve A function that resolves the promise.
	 * @param {Function} reject A function that rejects the promise.
	 * @param {object} response The response.
	 */
	settle = function settle(resolve, reject, response) {
	  var validateStatus = response.config.validateStatus;
	  if (!response.status || !validateStatus || validateStatus(response.status)) {
	    resolve(response);
	  } else {
	    reject(createError(
	      'Request failed with status code ' + response.status,
	      response.config,
	      null,
	      response.request,
	      response
	    ));
	  }
	};
	return settle;
}

var cookies;
var hasRequiredCookies;

function requireCookies () {
	if (hasRequiredCookies) return cookies;
	hasRequiredCookies = 1;

	var utils = utils$9;

	cookies = (
	  utils.isStandardBrowserEnv() ?

	  // Standard browser envs support document.cookie
	    (function standardBrowserEnv() {
	      return {
	        write: function write(name, value, expires, path, domain, secure) {
	          var cookie = [];
	          cookie.push(name + '=' + encodeURIComponent(value));

	          if (utils.isNumber(expires)) {
	            cookie.push('expires=' + new Date(expires).toGMTString());
	          }

	          if (utils.isString(path)) {
	            cookie.push('path=' + path);
	          }

	          if (utils.isString(domain)) {
	            cookie.push('domain=' + domain);
	          }

	          if (secure === true) {
	            cookie.push('secure');
	          }

	          document.cookie = cookie.join('; ');
	        },

	        read: function read(name) {
	          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
	          return (match ? decodeURIComponent(match[3]) : null);
	        },

	        remove: function remove(name) {
	          this.write(name, '', Date.now() - 86400000);
	        }
	      };
	    })() :

	  // Non standard browser env (web workers, react-native) lack needed support.
	    (function nonStandardBrowserEnv() {
	      return {
	        write: function write() {},
	        read: function read() { return null; },
	        remove: function remove() {}
	      };
	    })()
	);
	return cookies;
}

var isAbsoluteURL;
var hasRequiredIsAbsoluteURL;

function requireIsAbsoluteURL () {
	if (hasRequiredIsAbsoluteURL) return isAbsoluteURL;
	hasRequiredIsAbsoluteURL = 1;

	/**
	 * Determines whether the specified URL is absolute
	 *
	 * @param {string} url The URL to test
	 * @returns {boolean} True if the specified URL is absolute, otherwise false
	 */
	isAbsoluteURL = function isAbsoluteURL(url) {
	  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
	  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
	  // by any combination of letters, digits, plus, period, or hyphen.
	  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
	};
	return isAbsoluteURL;
}

var combineURLs;
var hasRequiredCombineURLs;

function requireCombineURLs () {
	if (hasRequiredCombineURLs) return combineURLs;
	hasRequiredCombineURLs = 1;

	/**
	 * Creates a new URL by combining the specified URLs
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} relativeURL The relative URL
	 * @returns {string} The combined URL
	 */
	combineURLs = function combineURLs(baseURL, relativeURL) {
	  return relativeURL
	    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
	    : baseURL;
	};
	return combineURLs;
}

var buildFullPath;
var hasRequiredBuildFullPath;

function requireBuildFullPath () {
	if (hasRequiredBuildFullPath) return buildFullPath;
	hasRequiredBuildFullPath = 1;

	var isAbsoluteURL = requireIsAbsoluteURL();
	var combineURLs = requireCombineURLs();

	/**
	 * Creates a new URL by combining the baseURL with the requestedURL,
	 * only when the requestedURL is not already an absolute URL.
	 * If the requestURL is absolute, this function returns the requestedURL untouched.
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} requestedURL Absolute or relative URL to combine
	 * @returns {string} The combined full path
	 */
	buildFullPath = function buildFullPath(baseURL, requestedURL) {
	  if (baseURL && !isAbsoluteURL(requestedURL)) {
	    return combineURLs(baseURL, requestedURL);
	  }
	  return requestedURL;
	};
	return buildFullPath;
}

var parseHeaders;
var hasRequiredParseHeaders;

function requireParseHeaders () {
	if (hasRequiredParseHeaders) return parseHeaders;
	hasRequiredParseHeaders = 1;

	var utils = utils$9;

	// Headers whose duplicates are ignored by node
	// c.f. https://nodejs.org/api/http.html#http_message_headers
	var ignoreDuplicateOf = [
	  'age', 'authorization', 'content-length', 'content-type', 'etag',
	  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
	  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
	  'referer', 'retry-after', 'user-agent'
	];

	/**
	 * Parse headers into an object
	 *
	 * ```
	 * Date: Wed, 27 Aug 2014 08:58:49 GMT
	 * Content-Type: application/json
	 * Connection: keep-alive
	 * Transfer-Encoding: chunked
	 * ```
	 *
	 * @param {String} headers Headers needing to be parsed
	 * @returns {Object} Headers parsed into an object
	 */
	parseHeaders = function parseHeaders(headers) {
	  var parsed = {};
	  var key;
	  var val;
	  var i;

	  if (!headers) { return parsed; }

	  utils.forEach(headers.split('\n'), function parser(line) {
	    i = line.indexOf(':');
	    key = utils.trim(line.substr(0, i)).toLowerCase();
	    val = utils.trim(line.substr(i + 1));

	    if (key) {
	      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
	        return;
	      }
	      if (key === 'set-cookie') {
	        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
	      } else {
	        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	      }
	    }
	  });

	  return parsed;
	};
	return parseHeaders;
}

var isURLSameOrigin;
var hasRequiredIsURLSameOrigin;

function requireIsURLSameOrigin () {
	if (hasRequiredIsURLSameOrigin) return isURLSameOrigin;
	hasRequiredIsURLSameOrigin = 1;

	var utils = utils$9;

	isURLSameOrigin = (
	  utils.isStandardBrowserEnv() ?

	  // Standard browser envs have full support of the APIs needed to test
	  // whether the request URL is of the same origin as current location.
	    (function standardBrowserEnv() {
	      var msie = /(msie|trident)/i.test(navigator.userAgent);
	      var urlParsingNode = document.createElement('a');
	      var originURL;

	      /**
	    * Parse a URL to discover it's components
	    *
	    * @param {String} url The URL to be parsed
	    * @returns {Object}
	    */
	      function resolveURL(url) {
	        var href = url;

	        if (msie) {
	        // IE needs attribute set twice to normalize properties
	          urlParsingNode.setAttribute('href', href);
	          href = urlParsingNode.href;
	        }

	        urlParsingNode.setAttribute('href', href);

	        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
	        return {
	          href: urlParsingNode.href,
	          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	          host: urlParsingNode.host,
	          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	          hostname: urlParsingNode.hostname,
	          port: urlParsingNode.port,
	          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
	            urlParsingNode.pathname :
	            '/' + urlParsingNode.pathname
	        };
	      }

	      originURL = resolveURL(window.location.href);

	      /**
	    * Determine if a URL shares the same origin as the current location
	    *
	    * @param {String} requestURL The URL to test
	    * @returns {boolean} True if URL shares the same origin, otherwise false
	    */
	      return function isURLSameOrigin(requestURL) {
	        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
	        return (parsed.protocol === originURL.protocol &&
	            parsed.host === originURL.host);
	      };
	    })() :

	  // Non standard browser envs (web workers, react-native) lack needed support.
	    (function nonStandardBrowserEnv() {
	      return function isURLSameOrigin() {
	        return true;
	      };
	    })()
	);
	return isURLSameOrigin;
}

var xhr;
var hasRequiredXhr;

function requireXhr () {
	if (hasRequiredXhr) return xhr;
	hasRequiredXhr = 1;

	var utils = utils$9;
	var settle = requireSettle();
	var cookies = requireCookies();
	var buildURL = buildURL$1;
	var buildFullPath = requireBuildFullPath();
	var parseHeaders = requireParseHeaders();
	var isURLSameOrigin = requireIsURLSameOrigin();
	var createError = requireCreateError();

	xhr = function xhrAdapter(config) {
	  return new Promise(function dispatchXhrRequest(resolve, reject) {
	    var requestData = config.data;
	    var requestHeaders = config.headers;
	    var responseType = config.responseType;

	    if (utils.isFormData(requestData)) {
	      delete requestHeaders['Content-Type']; // Let the browser set it
	    }

	    var request = new XMLHttpRequest();

	    // HTTP basic authentication
	    if (config.auth) {
	      var username = config.auth.username || '';
	      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
	      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
	    }

	    var fullPath = buildFullPath(config.baseURL, config.url);
	    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

	    // Set the request timeout in MS
	    request.timeout = config.timeout;

	    function onloadend() {
	      if (!request) {
	        return;
	      }
	      // Prepare the response
	      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
	      var responseData = !responseType || responseType === 'text' ||  responseType === 'json' ?
	        request.responseText : request.response;
	      var response = {
	        data: responseData,
	        status: request.status,
	        statusText: request.statusText,
	        headers: responseHeaders,
	        config: config,
	        request: request
	      };

	      settle(resolve, reject, response);

	      // Clean up request
	      request = null;
	    }

	    if ('onloadend' in request) {
	      // Use onloadend if available
	      request.onloadend = onloadend;
	    } else {
	      // Listen for ready state to emulate onloadend
	      request.onreadystatechange = function handleLoad() {
	        if (!request || request.readyState !== 4) {
	          return;
	        }

	        // The request errored out and we didn't get a response, this will be
	        // handled by onerror instead
	        // With one exception: request that using file: protocol, most browsers
	        // will return status as 0 even though it's a successful request
	        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
	          return;
	        }
	        // readystate handler is calling before onerror or ontimeout handlers,
	        // so we should call onloadend on the next 'tick'
	        setTimeout(onloadend);
	      };
	    }

	    // Handle browser request cancellation (as opposed to a manual cancellation)
	    request.onabort = function handleAbort() {
	      if (!request) {
	        return;
	      }

	      reject(createError('Request aborted', config, 'ECONNABORTED', request));

	      // Clean up request
	      request = null;
	    };

	    // Handle low level network errors
	    request.onerror = function handleError() {
	      // Real errors are hidden from us by the browser
	      // onerror should only fire if it's a network error
	      reject(createError('Network Error', config, null, request));

	      // Clean up request
	      request = null;
	    };

	    // Handle timeout
	    request.ontimeout = function handleTimeout() {
	      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
	      if (config.timeoutErrorMessage) {
	        timeoutErrorMessage = config.timeoutErrorMessage;
	      }
	      reject(createError(
	        timeoutErrorMessage,
	        config,
	        config.transitional && config.transitional.clarifyTimeoutError ? 'ETIMEDOUT' : 'ECONNABORTED',
	        request));

	      // Clean up request
	      request = null;
	    };

	    // Add xsrf header
	    // This is only done if running in a standard browser environment.
	    // Specifically not if we're in a web worker, or react-native.
	    if (utils.isStandardBrowserEnv()) {
	      // Add xsrf header
	      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
	        cookies.read(config.xsrfCookieName) :
	        undefined;

	      if (xsrfValue) {
	        requestHeaders[config.xsrfHeaderName] = xsrfValue;
	      }
	    }

	    // Add headers to the request
	    if ('setRequestHeader' in request) {
	      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
	        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
	          // Remove Content-Type if data is undefined
	          delete requestHeaders[key];
	        } else {
	          // Otherwise add header to the request
	          request.setRequestHeader(key, val);
	        }
	      });
	    }

	    // Add withCredentials to request if needed
	    if (!utils.isUndefined(config.withCredentials)) {
	      request.withCredentials = !!config.withCredentials;
	    }

	    // Add responseType to request if needed
	    if (responseType && responseType !== 'json') {
	      request.responseType = config.responseType;
	    }

	    // Handle progress if needed
	    if (typeof config.onDownloadProgress === 'function') {
	      request.addEventListener('progress', config.onDownloadProgress);
	    }

	    // Not all browsers support upload events
	    if (typeof config.onUploadProgress === 'function' && request.upload) {
	      request.upload.addEventListener('progress', config.onUploadProgress);
	    }

	    if (config.cancelToken) {
	      // Handle cancellation
	      config.cancelToken.promise.then(function onCanceled(cancel) {
	        if (!request) {
	          return;
	        }

	        request.abort();
	        reject(cancel);
	        // Clean up request
	        request = null;
	      });
	    }

	    if (!requestData) {
	      requestData = null;
	    }

	    // Send the request
	    request.send(requestData);
	  });
	};
	return xhr;
}

var utils$5 = utils$9;
var normalizeHeaderName = normalizeHeaderName$1;
var enhanceError = enhanceError$1;

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils$5.isUndefined(headers) && utils$5.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = requireXhr();
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = requireXhr();
  }
  return adapter;
}

function stringifySafely(rawValue, parser, encoder) {
  if (utils$5.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils$5.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

var defaults$3 = {

  transitional: {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
  },

  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');

    if (utils$5.isFormData(data) ||
      utils$5.isArrayBuffer(data) ||
      utils$5.isBuffer(data) ||
      utils$5.isStream(data) ||
      utils$5.isFile(data) ||
      utils$5.isBlob(data)
    ) {
      return data;
    }
    if (utils$5.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils$5.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils$5.isObject(data) || (headers && headers['Content-Type'] === 'application/json')) {
      setContentTypeIfUnset(headers, 'application/json');
      return stringifySafely(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    var transitional = this.transitional;
    var silentJSONParsing = transitional && transitional.silentJSONParsing;
    var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';

    if (strictJSONParsing || (forcedJSONParsing && utils$5.isString(data) && data.length)) {
      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw enhanceError(e, this, 'E_JSON_PARSE');
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults$3.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils$5.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults$3.headers[method] = {};
});

utils$5.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults$3.headers[method] = utils$5.merge(DEFAULT_CONTENT_TYPE);
});

var defaults_1 = defaults$3;

var utils$4 = utils$9;
var defaults$2 = defaults_1;

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
var transformData$1 = function transformData(data, headers, fns) {
  var context = this || defaults$2;
  /*eslint no-param-reassign:0*/
  utils$4.forEach(fns, function transform(fn) {
    data = fn.call(context, data, headers);
  });

  return data;
};

var isCancel$1;
var hasRequiredIsCancel;

function requireIsCancel () {
	if (hasRequiredIsCancel) return isCancel$1;
	hasRequiredIsCancel = 1;

	isCancel$1 = function isCancel(value) {
	  return !!(value && value.__CANCEL__);
	};
	return isCancel$1;
}

var utils$3 = utils$9;
var transformData = transformData$1;
var isCancel = requireIsCancel();
var defaults$1 = defaults_1;

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
var dispatchRequest$1 = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData.call(
    config,
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils$3.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils$3.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults$1.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};

var utils$2 = utils$9;

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
var mergeConfig$2 = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy', 'params'];
  var defaultToConfig2Keys = [
    'baseURL', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'timeoutMessage', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress', 'decompress',
    'maxContentLength', 'maxBodyLength', 'maxRedirects', 'transport', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath', 'responseEncoding'
  ];
  var directMergeKeys = ['validateStatus'];

  function getMergedValue(target, source) {
    if (utils$2.isPlainObject(target) && utils$2.isPlainObject(source)) {
      return utils$2.merge(target, source);
    } else if (utils$2.isPlainObject(source)) {
      return utils$2.merge({}, source);
    } else if (utils$2.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  function mergeDeepProperties(prop) {
    if (!utils$2.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (!utils$2.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  }

  utils$2.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (!utils$2.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    }
  });

  utils$2.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);

  utils$2.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (!utils$2.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    } else if (!utils$2.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });

  utils$2.forEach(directMergeKeys, function merge(prop) {
    if (prop in config2) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys)
    .concat(directMergeKeys);

  var otherKeys = Object
    .keys(config1)
    .concat(Object.keys(config2))
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils$2.forEach(otherKeys, mergeDeepProperties);

  return config;
};

var name = "axios";
var version$1 = "0.21.4";
var description = "Promise based HTTP client for the browser and node.js";
var main = "index.js";
var scripts = {
	test: "grunt test",
	start: "node ./sandbox/server.js",
	build: "NODE_ENV=production grunt build",
	preversion: "npm test",
	version: "npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json",
	postversion: "git push && git push --tags",
	examples: "node ./examples/server.js",
	coveralls: "cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js",
	fix: "eslint --fix lib/**/*.js"
};
var repository = {
	type: "git",
	url: "https://github.com/axios/axios.git"
};
var keywords = [
	"xhr",
	"http",
	"ajax",
	"promise",
	"node"
];
var author = "Matt Zabriskie";
var license = "MIT";
var bugs = {
	url: "https://github.com/axios/axios/issues"
};
var homepage = "https://axios-http.com";
var devDependencies = {
	coveralls: "^3.0.0",
	"es6-promise": "^4.2.4",
	grunt: "^1.3.0",
	"grunt-banner": "^0.6.0",
	"grunt-cli": "^1.2.0",
	"grunt-contrib-clean": "^1.1.0",
	"grunt-contrib-watch": "^1.0.0",
	"grunt-eslint": "^23.0.0",
	"grunt-karma": "^4.0.0",
	"grunt-mocha-test": "^0.13.3",
	"grunt-ts": "^6.0.0-beta.19",
	"grunt-webpack": "^4.0.2",
	"istanbul-instrumenter-loader": "^1.0.0",
	"jasmine-core": "^2.4.1",
	karma: "^6.3.2",
	"karma-chrome-launcher": "^3.1.0",
	"karma-firefox-launcher": "^2.1.0",
	"karma-jasmine": "^1.1.1",
	"karma-jasmine-ajax": "^0.1.13",
	"karma-safari-launcher": "^1.0.0",
	"karma-sauce-launcher": "^4.3.6",
	"karma-sinon": "^1.0.5",
	"karma-sourcemap-loader": "^0.3.8",
	"karma-webpack": "^4.0.2",
	"load-grunt-tasks": "^3.5.2",
	minimist: "^1.2.0",
	mocha: "^8.2.1",
	sinon: "^4.5.0",
	"terser-webpack-plugin": "^4.2.3",
	typescript: "^4.0.5",
	"url-search-params": "^0.10.0",
	webpack: "^4.44.2",
	"webpack-dev-server": "^3.11.0"
};
var browser = {
	"./lib/adapters/http.js": "./lib/adapters/xhr.js"
};
var jsdelivr = "dist/axios.min.js";
var unpkg = "dist/axios.min.js";
var typings = "./index.d.ts";
var dependencies = {
	"follow-redirects": "^1.14.0"
};
var bundlesize = [
	{
		path: "./dist/axios.min.js",
		threshold: "5kB"
	}
];
var require$$0 = {
	name: name,
	version: version$1,
	description: description,
	main: main,
	scripts: scripts,
	repository: repository,
	keywords: keywords,
	author: author,
	license: license,
	bugs: bugs,
	homepage: homepage,
	devDependencies: devDependencies,
	browser: browser,
	jsdelivr: jsdelivr,
	unpkg: unpkg,
	typings: typings,
	dependencies: dependencies,
	bundlesize: bundlesize
};

var pkg = require$$0;

var validators$1 = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach(function(type, i) {
  validators$1[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

var deprecatedWarnings = {};
var currentVerArr = pkg.version.split('.');

/**
 * Compare package versions
 * @param {string} version
 * @param {string?} thanVersion
 * @returns {boolean}
 */
function isOlderVersion(version, thanVersion) {
  var pkgVersionArr = thanVersion ? thanVersion.split('.') : currentVerArr;
  var destVer = version.split('.');
  for (var i = 0; i < 3; i++) {
    if (pkgVersionArr[i] > destVer[i]) {
      return true;
    } else if (pkgVersionArr[i] < destVer[i]) {
      return false;
    }
  }
  return false;
}

/**
 * Transitional option validator
 * @param {function|boolean?} validator
 * @param {string?} version
 * @param {string} message
 * @returns {function}
 */
validators$1.transitional = function transitional(validator, version, message) {
  var isDeprecated = version && isOlderVersion(version);

  function formatMessage(opt, desc) {
    return '[Axios v' + pkg.version + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return function(value, opt, opts) {
    if (validator === false) {
      throw new Error(formatMessage(opt, ' has been removed in ' + version));
    }

    if (isDeprecated && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new TypeError('options must be an object');
  }
  var keys = Object.keys(options);
  var i = keys.length;
  while (i-- > 0) {
    var opt = keys[i];
    var validator = schema[opt];
    if (validator) {
      var value = options[opt];
      var result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new TypeError('option ' + opt + ' must be ' + result);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw Error('Unknown option ' + opt);
    }
  }
}

var validator$1 = {
  isOlderVersion: isOlderVersion,
  assertOptions: assertOptions,
  validators: validators$1
};

var utils$1 = utils$9;
var buildURL = buildURL$1;
var InterceptorManager = InterceptorManager_1;
var dispatchRequest = dispatchRequest$1;
var mergeConfig$1 = mergeConfig$2;
var validator = validator$1;

var validators = validator.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios$1(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios$1.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig$1(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  var transitional = config.transitional;

  if (transitional !== undefined) {
    validator.assertOptions(transitional, {
      silentJSONParsing: validators.transitional(validators.boolean, '1.0.0'),
      forcedJSONParsing: validators.transitional(validators.boolean, '1.0.0'),
      clarifyTimeoutError: validators.transitional(validators.boolean, '1.0.0')
    }, false);
  }

  // filter out skipped interceptors
  var requestInterceptorChain = [];
  var synchronousRequestInterceptors = true;
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
      return;
    }

    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  var responseInterceptorChain = [];
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
  });

  var promise;

  if (!synchronousRequestInterceptors) {
    var chain = [dispatchRequest, undefined];

    Array.prototype.unshift.apply(chain, requestInterceptorChain);
    chain = chain.concat(responseInterceptorChain);

    promise = Promise.resolve(config);
    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }

    return promise;
  }


  var newConfig = config;
  while (requestInterceptorChain.length) {
    var onFulfilled = requestInterceptorChain.shift();
    var onRejected = requestInterceptorChain.shift();
    try {
      newConfig = onFulfilled(newConfig);
    } catch (error) {
      onRejected(error);
      break;
    }
  }

  try {
    promise = dispatchRequest(newConfig);
  } catch (error) {
    return Promise.reject(error);
  }

  while (responseInterceptorChain.length) {
    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
  }

  return promise;
};

Axios$1.prototype.getUri = function getUri(config) {
  config = mergeConfig$1(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils$1.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios$1.prototype[method] = function(url, config) {
    return this.request(mergeConfig$1(config || {}, {
      method: method,
      url: url,
      data: (config || {}).data
    }));
  };
});

utils$1.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios$1.prototype[method] = function(url, data, config) {
    return this.request(mergeConfig$1(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

var Axios_1 = Axios$1;

var Cancel_1;
var hasRequiredCancel;

function requireCancel () {
	if (hasRequiredCancel) return Cancel_1;
	hasRequiredCancel = 1;

	/**
	 * A `Cancel` is an object that is thrown when an operation is canceled.
	 *
	 * @class
	 * @param {string=} message The message.
	 */
	function Cancel(message) {
	  this.message = message;
	}

	Cancel.prototype.toString = function toString() {
	  return 'Cancel' + (this.message ? ': ' + this.message : '');
	};

	Cancel.prototype.__CANCEL__ = true;

	Cancel_1 = Cancel;
	return Cancel_1;
}

var CancelToken_1;
var hasRequiredCancelToken;

function requireCancelToken () {
	if (hasRequiredCancelToken) return CancelToken_1;
	hasRequiredCancelToken = 1;

	var Cancel = requireCancel();

	/**
	 * A `CancelToken` is an object that can be used to request cancellation of an operation.
	 *
	 * @class
	 * @param {Function} executor The executor function.
	 */
	function CancelToken(executor) {
	  if (typeof executor !== 'function') {
	    throw new TypeError('executor must be a function.');
	  }

	  var resolvePromise;
	  this.promise = new Promise(function promiseExecutor(resolve) {
	    resolvePromise = resolve;
	  });

	  var token = this;
	  executor(function cancel(message) {
	    if (token.reason) {
	      // Cancellation has already been requested
	      return;
	    }

	    token.reason = new Cancel(message);
	    resolvePromise(token.reason);
	  });
	}

	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	CancelToken.prototype.throwIfRequested = function throwIfRequested() {
	  if (this.reason) {
	    throw this.reason;
	  }
	};

	/**
	 * Returns an object that contains a new `CancelToken` and a function that, when called,
	 * cancels the `CancelToken`.
	 */
	CancelToken.source = function source() {
	  var cancel;
	  var token = new CancelToken(function executor(c) {
	    cancel = c;
	  });
	  return {
	    token: token,
	    cancel: cancel
	  };
	};

	CancelToken_1 = CancelToken;
	return CancelToken_1;
}

var spread;
var hasRequiredSpread;

function requireSpread () {
	if (hasRequiredSpread) return spread;
	hasRequiredSpread = 1;

	/**
	 * Syntactic sugar for invoking a function and expanding an array for arguments.
	 *
	 * Common use case would be to use `Function.prototype.apply`.
	 *
	 *  ```js
	 *  function f(x, y, z) {}
	 *  var args = [1, 2, 3];
	 *  f.apply(null, args);
	 *  ```
	 *
	 * With `spread` this example can be re-written.
	 *
	 *  ```js
	 *  spread(function(x, y, z) {})([1, 2, 3]);
	 *  ```
	 *
	 * @param {Function} callback
	 * @returns {Function}
	 */
	spread = function spread(callback) {
	  return function wrap(arr) {
	    return callback.apply(null, arr);
	  };
	};
	return spread;
}

var isAxiosError;
var hasRequiredIsAxiosError;

function requireIsAxiosError () {
	if (hasRequiredIsAxiosError) return isAxiosError;
	hasRequiredIsAxiosError = 1;

	/**
	 * Determines whether the payload is an error thrown by Axios
	 *
	 * @param {*} payload The value to test
	 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
	 */
	isAxiosError = function isAxiosError(payload) {
	  return (typeof payload === 'object') && (payload.isAxiosError === true);
	};
	return isAxiosError;
}

var utils = utils$9;
var bind = bind$2;
var Axios = Axios_1;
var mergeConfig = mergeConfig$2;
var defaults = defaults_1;

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios$1 = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios$1.Axios = Axios;

// Factory for creating new instances
axios$1.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios$1.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios$1.Cancel = requireCancel();
axios$1.CancelToken = requireCancelToken();
axios$1.isCancel = requireIsCancel();

// Expose all/spread
axios$1.all = function all(promises) {
  return Promise.all(promises);
};
axios$1.spread = requireSpread();

// Expose isAxiosError
axios$1.isAxiosError = requireIsAxiosError();

axios$2.exports = axios$1;

// Allow use of default import syntax in TypeScript
axios$2.exports.default = axios$1;

(function (module) {
	module.exports = axios$2.exports;
} (axios$3));

var axios = /*@__PURE__*/getDefaultExportFromCjs(axios$3.exports);

class AuthService {
  getAuthStatus(urlParamValue) {
    const accessLevelURL = "/loyalty/access-level";
    return axios.get(urlParamValue ? `${accessLevelURL}?locale=${urlParamValue}` : accessLevelURL).then(res => {
      return res.data;
    }).catch(err => {
      throw err;
    });
  }
  getMemberInformation() {
    return axios.get("/loyalty/api/member-information").then(resp => {
      return resp.data;
    }).catch(err => {
      console.log("Loyalty api error", err);
    });
  }
}

var AuthStatus = /* @__PURE__ */(AuthStatus2 => {
  AuthStatus2["GUEST"] = "0";
  AuthStatus2["UNSECURED"] = "1";
  AuthStatus2["SECURED"] = "2";
  return AuthStatus2;
})(AuthStatus || {});

const LoginStatus = ["nonmembers", "unsecure-members", "secure-members"];

var desktopConfig = {
	newWinText: "Opens in a new window.",
	newWinTextExternal: "Opens another site in a new window that may not meet accessibility guidelines.",
	columns: [
		{
			Heading: "Help",
			Links: [
				{
					Link: "Contact American",
					URL: "/i18n/customer-service/contact-american/american-customer-service.jsp?anchorEvent=false&from=footer",
					external: false,
					newWin: false
				},
				{
					Link: "Receipts and refunds",
					URL: "/i18n/customer-service/contact-american/receipts-and-refunds.jsp?anchorEvent=false&from=footer",
					external: false,
					newWin: false
				},
				{
					Link: "FAQs",
					URL: "/i18n/customer-service/faqs/faqs.jsp?anchorEvent=false&from=footer",
					external: false,
					newWin: false
				},
				{
					Link: "Agency reference",
					URL: "/i18n/customer-service/travel-professional-online-resources.jsp?anchorEvent=false&from=footer",
					external: false,
					newWin: false
				},
				{
					Link: "Cargo ",
					URL: "https://www.aacargo.com/",
					external: true,
					newWin: true
				},
				{
					Link: "Bag and optional fees",
					URL: "/i18n/customer-service/support/optional-service-fees.jsp?anchorEvent=false&from=footer",
					external: false,
					newWin: false
				},
				{
					Link: "Customer service and contingency plans",
					URL: "/i18n/customer-service/support/contingency-plans.jsp?anchorEvent=false&from=footer?",
					external: false,
					newWin: false
				},
				{
					Link: "Conditions of carriage",
					URL: "/i18n/customer-service/support/conditions-of-carriage.jsp?anchorEvent=false&from=footer?",
					external: false,
					newWin: false
				}
			]
		},
		{
			Heading: "About American",
			Links: [
				{
					Link: "About us",
					URL: "/i18n/customer-service/about-us/about-us.jsp?anchorEvent=false&from=footer",
					external: false,
					newWin: false
				},
				{
					Link: "We're hiring! Join our team ",
					URL: "https://jobs.aa.com/?utm_source=CorpSite&utm_campaign=aa.comownedchannel",
					external: true,
					newWin: true
				},
				{
					Link: "Investor relations ",
					URL: "http://phx.corporate-ir.net/phoenix.zhtml?c=117098&p=irol-IRHome",
					external: true,
					newWin: true
				},
				{
					Link: "Newsroom ",
					URL: "http://news.aa.com/",
					external: true,
					newWin: true
				},
				{
					Link: "Legal, privacy, copyright",
					URL: "/i18n/customer-service/support/legal-privacy-copyright.jsp?anchorEvent=false&from=footer",
					external: false,
					newWin: false
				},
				{
					Link: "Environmental, social and governance",
					URL: "https://news.aa.com/esg/",
					external: true,
					newWin: true
				},
				{
					Link: "Combating human trafficking",
					URL: "/i18n/customer-service/about-us/combating-human-trafficking.jsp?anchorEvent=false&from=footer",
					external: false,
					newWin: false
				},
				{
					Link: "Browser compatibility",
					URL: "/i18n/customer-service/support/browser-compatibility.jsp?anchorEvent=false&from=footer",
					external: false,
					newWin: false
				},
				{
					Link: "Web accessibility",
					URL: "/i18n/customer-service/about-us/web-accessibility.jsp?anchorEvent=false&from=footer",
					external: false,
					newWin: false
				}
			]
		},
		{
			Heading: "Extras",
			Links: [
				{
					Link: "Business programs ",
					URL: "/i18n/customer-service/programs-products/business-travel-services.jsp",
					external: false,
					newWin: false
				},
				{
					Link: "Gift cards ",
					URL: "https://www.americanairlines.com/giftcards",
					external: true,
					newWin: true
				},
				{
					Link: "American Airlines credit card",
					URL: "/i18n/customer-service/payment-options/american-airlines-credit-card.jsp?anchorEvent=false&from=footer",
					external: false,
					newWin: false
				},
				{
					Link: "Trip insurance",
					URL: "/i18n/plan-travel/extras/trip-insurance.jsp?anchorEvent=false&from=footer",
					external: false,
					newWin: false
				}
			]
		}
	],
	footnote: [
		{
			standard: {
				icon: true,
				text: "Link opens in new window. Site may not meet accessibility guidelines. AA.com® "
			}
		},
		{
			multiline: [
				{
					text: "People Entitled : Adam Pope Address: American Airlines, Inc., Orient House (HAA3), Po Box 365, Waterside, Harmondsworth, UB7 0GB, United Kingdom"
				},
				{
					link: {
						preLinkText: "Email: ",
						linkText: "International.CustomerRelations@aa.com",
						href: "mailto:damien.wiggins1@aa.com",
						external: false,
						newWin: false,
						chevron: false
					}
				},
				{
					text: "Phone: 0821-980-999 (Service 0,12 EUR/min + call charge)"
				},
				{
					link: {
						preLinkText: "Mediation procedure :",
						linkText: "Customer relations",
						href: "/i18n/customer-service/contact-american/customer-relations.jsp",
						external: true,
						newWin: true
					}
				}
			]
		}
	],
	socialLinks: [
		{
			href: "http://facebook.com/aa",
			image: {
				alternateText: "Facebook icon",
				file: "https://www.aa.com/content/images/chrome/rebrand/icon-footer-facebook.png"
			},
			external: true,
			newWin: true
		},
		{
			href: "http://youtube.com/americanairlines",
			image: {
				alternateText: "YouTube icon",
				file: "https://www.aa.com/content/images/chrome/rebrand/icon-footer-youtube.png"
			},
			external: true,
			newWin: true
		},
		{
			href: "http://twitter.com/americanair",
			image: {
				alternateText: "Twitter icon",
				file: "https://www.aa.com/content/images/chrome/rebrand/icon-footer-twitter.png"
			},
			external: false,
			newWin: false
		}
	]
};
var mobileConfig = {
	columns: [
		{
			Links: [
				{
					Link: "Receipts and refunds",
					URL: "/i18n/customer-service/contact-american/receipts-and-refunds.jsp?anchorEvent=false&from=footer",
					external: false,
					newWin: false
				},
				{
					Link: "Bag and optional fees",
					URL: "/i18n/customer-service/support/optional-service-fees.jsp?anchorEvent=false&from=footer",
					external: false,
					newWin: false
				},
				{
					Link: "Customer service and contingency plans",
					URL: "/i18n/customer-service/support/contingency-plans.jsp?anchorEvent=false&from=footer?",
					external: false,
					newWin: false
				},
				{
					Link: "Conditions of carriage",
					URL: "/i18n/customer-service/support/conditions-of-carriage.jsp?anchorEvent=false&from=footer?",
					external: false,
					newWin: false
				},
				{
					Link: "FAQs",
					URL: "/i18n/customer-service/faqs/faqs.jsp?anchorEvent=false&from=footer",
					external: false,
					newWin: false
				},
				{
					Link: "Contact",
					URL: "/i18n/customer-service/contact-american/american-customer-service.jsp?anchorEvent=false&from=footer",
					external: false,
					newWin: false
				}
			]
		}
	],
	socialLinks: [
		{
			href: "/i18n/travel-info/partner-airlines/oneworld-airline-partners.jsp",
			image: {
				alternateText: "oneworld logo",
				file: "https://www.aa.com/content/images/chrome/rebrand/oneworld.png"
			},
			external: false,
			newWin: false
		}
	],
	NoteLinks: [
		{
			Link: "Legal, privacy, copyright",
			URL: "/i18n/customer-service/support/legal-privacy-copyright.jsp",
			external: false,
			newWin: false
		},
		{
			Link: "Full site",
			URL: "/homePage.do?fullHTMLVersion=true&site_preference=normal",
			external: false,
			newWin: false
		}
	]
};
var footerData = {
	desktopConfig: desktopConfig,
	mobileConfig: mobileConfig
};

var data = /*#__PURE__*/Object.freeze({
	__proto__: null,
	desktopConfig: desktopConfig,
	mobileConfig: mobileConfig,
	'default': footerData
});

class GlobalDataController {
  static _isHomePage() {
    const homePage = /\/?home/i;
    const {
      href
    } = window.location;
    return homePage.test(href);
  }
  static getEnvironment() {
    const hostname = window.location.hostname;
    return /^.*\.stage\.aa\.com$/.test(hostname) ? "stage" : /^.*\.qa\.aa\.com$/.test(hostname) || hostname === "localhost" ? "qa" : "prod";
  }
}

class Rollup {}
Rollup.DATA = {
  "rollup": {
    "en_AG": ["en_CB"],
    "en_AI": ["en_CB"],
    "en_AW": ["en_CB"],
    "en_BB": ["en_CB"],
    "en_BM": ["en_CB"],
    "en_BQ": ["en_CB"],
    "en_BS": ["en_CB"],
    "en_CW": ["en_CB"],
    "en_DM": ["en_CB"],
    "en_GD": ["en_CB"],
    "en_HT": ["en_CB"],
    "en_JM": ["en_CB"],
    "en_KN": ["en_CB"],
    "en_KY": ["en_CB"],
    "en_LC": ["en_CB"],
    "en_SX": ["en_CB"],
    "en_TC": ["en_CB"],
    "en_TT": ["en_CB"],
    "en_VC": ["en_CB"],
    "en_VG": ["en_CB"],
    "es_US": ["es"],
    "es_AR": ["es"],
    "es_BO": ["es"],
    "es_CL": ["es"],
    "es_CO": ["es"],
    "es_CR": ["es"],
    "es_DO": ["es"],
    "es_EC": ["es"],
    "es_GT": ["es"],
    "es_HN": ["es"],
    "es_MX": ["es"],
    "es_NI": ["es"],
    "es_PA": ["es"],
    "es_PE": ["es"],
    "es_PR": ["es"],
    "es_PY": ["es"],
    "es_SV": ["es"],
    "es_UY": ["es"],
    "es_VE": ["es"],
    "en_CA": ["en_US"],
    "en_BZ": ["en_US"],
    "en_PR": ["en_US"],
    "pt_BR": ["pt"],
    "pt_PT": ["pt", "en_EU"],
    "en_BE": ["en_EU"],
    "en_CH": ["en_EU"],
    "en_CZ": ["en_EU"],
    "en_DE": ["en_EU"],
    "en_DK": ["en_EU"],
    "en_ES": ["en_EU"],
    "en_FI": ["en_EU"],
    "en_FR": ["en_EU"],
    "en_GB": ["en_EU"],
    "en_GR": ["en_EU"],
    "en_HR": ["en_EU"],
    "en_HU": ["en_EU"],
    "en_IE": ["en_EU"],
    "en_IL": ["en_EU"],
    "en_IS": ["en_EU"],
    "en_IT": ["en_EU"],
    "en_MA": ["en_EU"],
    "en_ME": ["en_EU"],
    "en_NL": ["en_EU"],
    "en_NO": ["en_EU"],
    "en_PL": ["en_EU"],
    "en_PT": ["en_EU"],
    "en_QA": ["en_EU"],
    "en_RU": ["en_EU"],
    "en_SE": ["en_EU"],
    "fr_BE": ["fr"],
    "fr_CA": ["fr"],
    "fr_CH": ["fr"],
    "fr_FR": ["fr"],
    "fr_MA": ["fr"],
    "it_IT": ["it", "en_EU"],
    "nl_NL": ["nl", "en_EU"],
    "nl_BE": ["nl", "en_EU"],
    "es_ES": ["es", "en_EU"],
    "de_DE": ["de", "en_EU"],
    "de_CH": ["de", "en_EU"],
    "fi_FI": ["fi", "en_EU"],
    "ru_RU": ["ru", "en_EU"],
    "en_AU": ["en_AP"],
    "en_CN": ["en_AP"],
    "en_HK": ["en_AP"],
    "en_IN": ["en_AP"],
    "en_JP": ["en_AP"],
    "en_KR": ["en_AP"],
    "en_NZ": ["en_AP"],
    "en_SG": ["en_AP"],
    "ja_JP": ["ja", "en_AP"],
    "ko_KR": ["ko", "en_AP"],
    "zh_CN": ["zh", "en_AP"],
    "zh_HK": ["zh", "en_AP"]
  }
};

var __defProp$1 = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp$1(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) {
    if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  return a;
};
const _TranslationDataController = class {
  static getLocaleTranslations(locale, componentTranslations) {
    const updateLocale = this.transformLocaleFormat(locale);
    const rollupLocales = ["en_US", ...(Rollup.DATA.rollup[updateLocale] || []).reverse(), updateLocale];
    for (const code of rollupLocales) {
      _TranslationDataController.translations = __spreadValues(__spreadValues({}, _TranslationDataController.translations), componentTranslations.DATA[code]);
    }
  }
  static transformLocaleFormat(s) {
    return s.replace("-", "_");
  }
  static _checkCookie() {
    let cookie = "en_US";
    const cookiesList = this.getCookies("sessionLocale");
    if (cookiesList.length > 0) {
      cookie = this.transformLocaleFormat(cookiesList[0]);
    }
    return cookie;
  }
  static updateCookie(urlParamValue) {
    const cookiesList = this.getCookies("sessionLocale");
    if (cookiesList.length > 1) {
      document.cookie = `sessionLocale=;max-age=0`;
    }
    document.cookie = `sessionLocale=${urlParamValue}; path=/`;
  }
  static updateCookiePref(urlParamValue) {
    const expirationDate = new Date();
    expirationDate.setFullYear(expirationDate.getFullYear() + 1);
    const baseUrl = document.location.hostname;
    const subdomain = baseUrl.includes(".qa.") ? baseUrl.slice(0, baseUrl.indexOf(".qa") + 3) : "www";
    document.cookie = `locale=${urlParamValue}; domain=.${subdomain}.aa.com; path=/; expires=${expirationDate.toUTCString()};`;
  }
  static retrieveLocale() {
    let locale = "en_US";
    const prefValue = this.getURLParam("pref");
    const urlParamValue = this.getURLParam("locale");
    if (urlParamValue) {
      const isCorrectFormat = this.checkLocaleFormat(urlParamValue);
      if (isCorrectFormat) {
        if (typeof urlParamValue === "string") {
          locale = this.transformLocaleFormat(urlParamValue);
        }
        if (!this.isCookieSetFromURL) {
          if (prefValue) {
            this.updateCookiePref(locale);
          }
          this.updateCookie(locale);
          this.isCookieSetFromURL = true;
        }
      }
    } else {
      const cookieValue = this._checkCookie();
      if (cookieValue !== null && cookieValue !== void 0) {
        locale = this.transformLocaleFormat(cookieValue);
      }
    }
    return locale;
  }
  static getURLParam(param) {
    const currentPageURL = new URLSearchParams(window.location.search);
    const urlParamValue = currentPageURL.get(param);
    if (param === "locale") {
      return urlParamValue !== null && urlParamValue !== void 0 ? urlParamValue : "";
    } else {
      return urlParamValue === "true";
    }
  }
  static async getTranslationData(componentName, protocol) {
    const locale = this.retrieveLocale();
    const isAmadeusOrLocal = ["localhost", "amadeus"].some(host => document.location.hostname.includes(host));
    const baseUrl = isAmadeusOrLocal ? document.location.hostname.includes("bookaa.amadeus") ? "www.aa.com" : "iqa2.qa.aa.com" : document.location.hostname;
    if (locale in Rollup.DATA.rollup) {
      const locales = [locale, ...Rollup.DATA.rollup[locale], "en_US"];
      for (const loc of locales) {
        try {
          const response = await axios.get(`${protocol}//${baseUrl}/pubcontent/${loc}/fragments/navigation/${componentName}/${componentName}-${loc}.json`);
          return response;
        } catch (error) {
          continue;
        }
      }
    } else {
      try {
        const response = await axios.get(`${protocol}//${baseUrl}/pubcontent/${locale}/fragments/navigation/${componentName}/${componentName}-${locale}.json`);
        return response;
      } catch (error) {
        return error;
      }
    }
  }
  static getLocaleRollup(localeCode) {
    return Rollup.DATA.rollup[localeCode];
  }
  static checkLocaleFormat(localeCode) {
    const pattern = new RegExp("^[a-z]{2}_[A-Z]{2}$");
    return pattern.test(localeCode);
  }
  static getCookies(cname) {
    const name = `${cname}=`;
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(";");
    const cookieList = [];
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.startsWith(" ")) {
        c = c.substring(1);
      }
      if (c.startsWith(name)) {
        cookieList.push(c.substring(name.length, c.length));
      }
    }
    return cookieList;
  }
};
let TranslationDataController = _TranslationDataController;
TranslationDataController.isCookieSetFromURL = false;
TranslationDataController.translations = {};

class FooterDataController {
  constructor(host) {
    this.authService = new AuthService();
    this.protocol = document.location.protocol;
    this.locale = TranslationDataController.retrieveLocale();
    this.authStatus = AuthStatus.GUEST;
    this.loginStatus = LoginStatus[0];
    this.aadvantageNumber = "";
    (this.host = host).addController(this);
  }
  hostConnected() {
    this.fetchData();
    this.getTarget().then(() => {
      this.host.requestUpdate();
    });
  }
  async fetchData() {
    const baseUrl = document.location.hostname;
    const protocol = document.location.protocol;
    if (baseUrl.includes("localhost") || baseUrl.includes("ideal-succotash")) {
      this.processData(data);
    } else {
      const response = await TranslationDataController.getTranslationData("footer", protocol);
      this.processData(response.data);
      this.host.requestUpdate();
    }
  }
  processData(jsonData) {
    this.linkData = jsonData;
  }
  async getTarget() {
    var _a;
    await this.getAuthStatus();
    if (this.authStatus === AuthStatus.SECURED) {
      try {
        const resp = await this.authService.getMemberInformation();
        this.memberInfo = resp;
        if (((_a = this.memberInfo) == null ? void 0 : _a.aadvantageNumber) !== void 0) {
          this.aadvantageNumber = this.memberInfo.aadvantageNumber;
        }
      } catch (err) {
        throw err;
      }
    }
    this.getTargetDetails();
  }
  async getAuthStatus() {
    await this.authService.getAuthStatus().then(resp => {
      this.authStatus = resp.status;
      this.loginStatus = LoginStatus[this.authStatus];
    }).catch(err => {
      const baseUrl = document.location.hostname;
      if (baseUrl.includes("aa.com") || baseUrl.includes("american")) {
        this.authStatus = AuthStatus.GUEST;
        this.loginStatus = LoginStatus[this.authStatus];
      }
      console.log("authStatus error, ", err);
    });
  }
  async getTargetDetails() {
    await axios.get(this.buildTargetedUrl()).then(resp => {
      this.targetDetails = resp.data;
      this.host.requestUpdate();
    }).catch(err => {
      console.log("", err);
    });
  }
  buildTargetedUrl() {
    const baseUrl = document.location.hostname;
    const isHomePage = GlobalDataController._isHomePage() ? "T" : "F";
    const contentURL = `locale=${this.locale}&loginStatus=${this.loginStatus}&min=1&max=3&subType=FooterMessage1&isHomePage=${isHomePage}&slot=true&aaAdvNum=${this.aadvantageNumber}`;
    let urlToFetch = "";
    if (baseUrl.includes("localhost") || baseUrl.includes("pages.github.io")) {
      urlToFetch = `${this.protocol}//aacom-qa-cluster-dal.us-south.containers.appdomain.cloud/tcs/v2/content/MarketingMessages?${contentURL}`;
    } else {
      urlToFetch = `${this.protocol}//${baseUrl}/targeted-content-service/v2/content/MarketingMessages?${contentURL}`;
    }
    return urlToFetch;
  }
}

class GlobalTranslations {}
GlobalTranslations.DATA = {
  "en_US": {
    "OneWorld": "oneworld link opens in a new window",
    "newWinText": ", Opens in a new window.",
    "newWinExtText": ", Opens another site in a new window that may not meet accessibility guidelines."
  },
  "es": {
    "OneWorld": "El enlace de oneworld abre en una nueva ventana",
    "newWinText": ", Abre en una nueva ventana.",
    "newWinExtText": ", Abre una nueva ventana de otro sitio web que podr\xEDa no cumplir con las normas de accesibilidad."
  },
  "fr": {
    "OneWorld": `Le lien oneworld s'ouvre dans une nouvelle fen\xEAtre`,
    "newWinText": ", Ouvre dans une nouvelle fen\xEAtre.",
    "newWinExtText": ", Ouvre un nouveau site dans une nouvelle fen\xEAtre pouvant ne pas respecter les directives d\u2019accessibilit\xE9."
  },
  "pt": {
    "OneWorld": "O link da oneworld abre em uma nova janela",
    "newWinText": ", Abre em uma nova janela.",
    "newWinExtText": ", Abre um outro site numa nova janela que pode n\xE3o cumprir as normas de acessibilidade."
  }
};

var esm = {};

var AileronLogger$1 = {};

var GenerateBrowserData = {};

Object.defineProperty(GenerateBrowserData, "__esModule", { value: true });
GenerateBrowserData.generateBrowserData = void 0;
function determineOS() {
    let OSName = "Unknown";
    if (window.navigator.userAgent.indexOf("Windows NT 10.0") != -1)
        OSName = "Windows 10";
    if (window.navigator.userAgent.indexOf("Windows NT 6.3") != -1)
        OSName = "Windows 8.1";
    if (window.navigator.userAgent.indexOf("Windows NT 6.2") != -1)
        OSName = "Windows 8";
    if (window.navigator.userAgent.indexOf("Windows NT 6.1") != -1)
        OSName = "Windows 7";
    if (window.navigator.userAgent.indexOf("Windows NT 6.0") != -1)
        OSName = "Windows Vista";
    if (window.navigator.userAgent.indexOf("Windows NT 5.1") != -1)
        OSName = "Windows XP";
    if (window.navigator.userAgent.indexOf("Windows NT 5.0") != -1)
        OSName = "Windows 2000";
    if (window.navigator.userAgent.indexOf("Mac") != -1)
        OSName = "Mac/iOS";
    if (window.navigator.userAgent.indexOf("X11") != -1)
        OSName = "UNIX";
    if (window.navigator.userAgent.indexOf("Linux") != -1)
        OSName = "Linux";
    return OSName;
}
function determineBrowser() {
    if (navigator.userAgent.indexOf("Chrome") > -1) {
        return "Chrome";
    }
    if (navigator.userAgent.indexOf("Firefox") > -1) {
        return "Firefox";
    }
    if (navigator.userAgent.indexOf("MSIE") > -1 || navigator.userAgent.indexOf("rv:") > -1) {
        return "Internet Explorer";
    }
    if (navigator.userAgent.indexOf("Safari") > -1) {
        if (navigator.userAgent.indexOf("Chrome") > -1) {
            return "Chrome";
        }
        else
            return "Safari";
    }
    return "N/A";
}
function generateBrowserData() {
    const browserData = {
        href: document.location.href,
        protocol: document.location.protocol,
        os: determineOS(),
        browser: determineBrowser(),
        host: document.location.host,
    };
    return browserData;
}
GenerateBrowserData.generateBrowserData = generateBrowserData;

var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(AileronLogger$1, "__esModule", { value: true });
AileronLogger$1.AileronLogger = void 0;
const GenerateBrowserData_1 = GenerateBrowserData;
class AileronLogger {
    constructor(appName, environment = 'prod') {
        this.appName = appName;
        this.browserData = (0, GenerateBrowserData_1.generateBrowserData)();
        this.environment = environment;
    }
    log(message, level = "info", additional) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const logData = {
                "message": message,
                "level": level,
                "default": this.browserData,
                "additional": additional
            };
            let logUrl;
            try {
                logUrl = 'https://' + ((_a = this.browserData) === null || _a === void 0 ? void 0 : _a.host) + '/aileron/api/log';
            }
            catch (e) {
                logUrl = 'https://www.aa.com/aileron/api/log';
            }
            let response;
            try {
                response = yield fetch(logUrl, {
                    method: 'POST',
                    headers: {
                        "Content-Type": "application/json",
                        "app": this.appName,
                        "env": this.environment
                    },
                    body: JSON.stringify(logData)
                });
            }
            catch (e) {
                response = e.message;
            }
            return response;
        });
    }
}
AileronLogger$1.AileronLogger = AileronLogger;

(function (exports) {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.AileronLogger = void 0;
	const AileronLogger_1 = AileronLogger$1;
	Object.defineProperty(exports, "AileronLogger", { enumerable: true, get: function () { return AileronLogger_1.AileronLogger; } });
} (esm));

class LogData {}
function Log(proto, _key) {
  const appName = "AACom-aileron-web";
  const urlToFetch = `${document.location.protocol}//${document.location.hostname}/pubcontent/en_US/fragments/aileron-web/aileron-logger-config.json`;
  let logLevel;
  let stack;
  let name;
  let message;
  let env = "prod";
  let config;
  let unhandledError = false;
  if (document.location.hostname.includes("stage.aa.com")) {
    env = "stage";
  } else if (document.location.hostname.includes("qa.aa.com") || document.location.hostname.includes("localhost")) {
    env = "qa";
  }
  const logger = new esm.AileronLogger(appName, env);
  const data = new LogData();
  const ctor = proto.constructor;
  window.onunhandledrejection = e => {
    unhandledError = true;
    const {
      reason
    } = e || {};
    const stack2 = reason.stack || "No stack available";
    const message2 = reason.message || "No message available";
    data.fullDetails = `Message: ${message2}
Stack: ${stack2}`;
  };
  ctor.addInitializer(async instance => {
    var _a, _b, _c, _d, _e;
    const sessionId = document.cookie.split("; QuantumMetricSessionID=");
    const userId = document.cookie.split("; QuantumMetricUserID=");
    try {
      config = await getLogSwitch(urlToFetch, env);
      logLevel = !unhandledError ? config == null ? void 0 : config.logLevel : 4 /* Error */;
      await instance.updateComplete;
      data.status = !unhandledError ? "success" : "Error";
      data.componentName = instance.tagName;
      data.componentVersion = instance["version"];
      data.loadTime = !unhandledError ? instance["loadTime"] : "";
      data.componentStatus = !unhandledError ? "200" : "500";
      data.location = document.location.hostname;
      data.level = !unhandledError ? "Info" : "Error";
      if (sessionId !== null && sessionId.length === 2) {
        data.QMSessionId = (_a = sessionId.pop()) == null ? void 0 : _a.split(";").shift();
      }
      if (userId !== null && userId.length === 2) {
        data.QMUserId = (_b = userId.pop()) == null ? void 0 : _b.split(";").shift();
      }
    } catch (e) {
      stack = e.stack;
      name = e.name;
      message = e.message;
      data.status = "Error";
      data.componentName = instance.tagName;
      data.componentVersion = instance["version"];
      data.componentStatus = "500";
      data.fullDetails = stack;
      data.location = document.location.hostname;
      data.level = "Error";
      if (sessionId !== null && sessionId.length === 2) {
        data.QMSessionId = (_c = sessionId.pop()) == null ? void 0 : _c.split(";").shift();
      }
      if (userId !== null && userId.length === 2) {
        data.QMUserId = (_d = userId.pop()) == null ? void 0 : _d.split(";").shift();
      }
      logLevel = 4 /* Error */;
    }
    const randomNum = Math.random();
    const loggingEnabled = config == null ? void 0 : config.loggingEnabled;
    const numerator = (_e = config == null ? void 0 : config.gradualRollout) == null ? void 0 : _e.numerator;
    const shouldLog = randomNum < numerator / 100;
    if (loggingEnabled) {
      if (logLevel === 0 /* Disabled */) {
        return;
      }
      if (shouldLog) {
        if (logLevel >= 4 /* Error */) {
          await logger.log(`${instance.tagName} ${instance["version"]} ${data.location} ${data.status} ${name} ${message}`, "Error", data);
        } else if (logLevel >= 3 /* Warn */) {
          await logger.log(`${instance.tagName} ${instance["version"]} ${data.location} ${data.status} ${name} ${message}`, data.level, data);
        } else if (logLevel >= 2 /* Info */) {
          await logger.log(`${instance.tagName} ${instance["version"]} ${data.location} ${data.status} ${data.loadTime}`, data.level, data);
        }
      }
    }
  });
  async function getLogSwitch(url, environment) {
    return fetch(url).then(resp => resp.json()).then(d => {
      return d.env.find(obj => obj.name.includes(environment));
    }).catch(() => {
      return null;
    });
  }
}

var version = "1.9.8";

const styles = css`.sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border-width:0}footer{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:"American Sans",sans-serif;font-family:var(--adc-typography-body1-font-family,var(--adc-typography-font-family,"American Sans",sans-serif));font-size:1rem;font-size:var(--adc-typography-body1-font-size,1rem);line-height:1.375rem;line-height:var(--adc-typography-body1-line-height,1.375rem);font-weight:400;font-weight:var(--adc-typography-body1-font-weight,400);letter-spacing:.01em;letter-spacing:var(--adc-typography-body1-letter-spacing,0.01em);text-decoration:inherit;-webkit-text-decoration:var(--adc-typography-body1-text-decoration,inherit);text-decoration:var(--adc-typography-body1-text-decoration,inherit);text-transform:inherit;text-transform:var(--adc-typography-body1-text-transform,inherit);font-family:AmericanSans,sans-serif;font-size:16px;bottom:0;left:0;width:100%;background-color:#d0dae0;box-sizing:border-box;padding:0 112px}footer h2{line-height:24px;color:var(--neutral-010);font-weight:400;font-size:1.286rem;margin-bottom:0;margin-top:24px}footer .grid-container{max-width:1216px;width:100%;margin-top:60px;padding-top:36px}footer .desktop-note{padding-bottom:24px}footer .footer-links{margin-bottom:12px}footer .target-ads{display:flex;flex-direction:column;margin-top:60px}footer .target-ads .content-ads{margin-bottom:24px}footer .divider::part(divider){margin-top:12px;margin-bottom:12px}footer .content-link::part(anchor){--icon-fill:#181e25;color:#181e25;text-decoration:none}footer .content-link::part(anchor):hover{--icon-fill:#00467f;color:#00467f;text-decoration:underline}footer .footer-left{color:var(--neutral-010)}footer .footer-right{text-align:right}footer .footer-right a{text-decoration:none;display:inline-block}footer .social-links{margin-left:12px}footer .social-links:focus{outline-color:#0a78f5;outline-offset:1px;outline-width:1px;outline-style:solid;border-radius:3.5px}footer .content-ads:focus{outline-color:#0a78f5;outline-offset:1px;outline-width:1px;outline-style:solid;border-radius:3.5px}footer .one-world-logo{display:flex;justify-content:flex-end}footer .mobile-footer-links{margin-bottom:12px}footer .mobile-footer-row{padding-top:18px}footer .mobile-view--visible{display:none !important}footer .mobile-footer-note{display:flex}footer .mobile-footer-icon{width:25px;height:25px}footer .mobile-note{padding-bottom:16px}footer .tab-note{display:none}@media screen and (max-width:799px){footer .mobile-view--hidden{display:none !important}footer .mobile-view--visible{display:inherit !important}}.note-link--with-icon{vertical-align:top}.note-link--hyperlink-text{display:inline}.note-link--hyperlink-text::part(anchor){color:var(--neutral-060);text-decoration:none;font-size:14px}.note-link--hyperlink-text::part(anchor):hover{text-decoration:underline}@media screen and (min-width:800px) and (max-width:1023px){footer{padding:0 32px}footer #mobileGridContainer{margin-top:0}footer .grid-container{margin-top:40px}footer .desktop-note{display:none}footer .tab-note{display:flex}footer .desktop-footer-row{flex-direction:column}footer .target-ads{flex-direction:row;margin-top:15px;align-items:end}footer .one-world{width:25px}footer .footer-left{margin-bottom:12px;margin-left:0}footer .tab-footer-right{margin-bottom:24px}}@media screen and (max-width:799px){footer{padding:0 16px}footer .grid-container{padding-top:0;margin-top:40px}footer #mobileGridContainer{margin-top:0}}`;

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--) if (decorator = decorators[i]) result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
registerComponent("hp-footer");
registerComponent$1("hp-footer");
registerComponent$2("hp-footer");
let Footer = class extends LitElement {
  constructor() {
    super(...arguments);
    this.localeCode = "en_US";
    this.data = new FooterDataController(this);
  }
  render() {
    this.startTime = new Date().getTime();
    this.localeCode = TranslationDataController.retrieveLocale();
    TranslationDataController.getLocaleTranslations(this.localeCode, GlobalTranslations);
    return html`
    <footer id="aa-footer">
      ${this.displayDesktop(this.data)}
      ${this.displayMobile(this.data.linkData)}
    </footer>
    `;
  }
  async getUpdateComplete() {
    const result = await super.getUpdateComplete();
    this.loadTime = new Date().getTime() - this.startTime;
    return result;
  }
  displayDesktop(data) {
    return html`
    <hp-footer-grid part="grid-container-desktop" class="grid-container mobile-view--hidden">
        <adc-row class="desktop-footer-row">
          ${this.desktopLinksConfig(data)}
        </adc-row>
        <adc-row>
          <adc-column col-desktop="12">
            <adc-divider class="divider"></adc-divider>
          </adc-column>
        </adc-row>
        <adc-row class="desktop-note">
          ${this.displayDesktopNote(data)}
        </adc-row>
        <adc-row class="tab-note">
          ${this.displayTabNote(data)}
        </adc-row>
    </hp-footer-grid>
  `;
  }
  displayMobile(data) {
    return html`
    <hp-footer-grid part="grid-container-mobile" id=${window.location.href.includes("/homePage.do") ? "mobileGridContainer" : ""} class="grid-container mobile-view--visible">
        <adc-row class="mobile-footer-row">
          ${this.mobileLinksConfig(data)}
        </adc-row>
        <adc-row>
          <adc-column>
            <adc-divider class="divider"></adc-divider>
          </adc-column>
        </adc-row>
        <adc-row class="mobile-note">
          ${this.displayMobileNote(data)}
        </adc-row>
    </hp-footer-grid>
  `;
  }
  desktopLinksConfig(data) {
    var _a, _b, _c;
    return html`
      ${(_b = (_a = data.linkData) == null ? void 0 : _a.desktopConfig) == null ? void 0 : _b.columns.map(column => html`
          <adc-column col-desktop="3">
            <h2>${column.Heading}</h2>
            <adc-divider class="divider"></adc-divider>
            ${column.Links.map(link => {
      var _a2, _b2, _c2, _d;
      return html`
              <hp-footer-link class="footer-links content-link"
                        hidden-label-text="${link.newWin ? link.external ? (_b2 = (_a2 = data.linkData) == null ? void 0 : _a2.desktopConfig) == null ? void 0 : _b2.newWinTextExternal : (_d = (_c2 = data.linkData) == null ? void 0 : _c2.desktopConfig) == null ? void 0 : _d.newWinText : ""}"
                        icon="${link.newWin ? "new-window" : ""}"
                        target="${link.newWin ? "_blank" : "_self"}"
                        href="${link.URL}">
                ${link.Link}
              </hp-footer-link>`;
    })}
          </adc-column>`)}

      <div class="target-ads">
        ${(_c = data.targetDetails) == null ? void 0 : _c.map(imageLink => html`
            <a class="content-ads" href="${imageLink.imageLink}" target="_blank">
              <img alt="${imageLink.altText}" src="${imageLink.image}">
            </a>
          `)}
      </div>
    `;
  }
  mobileLinksConfig(data) {
    var _a;
    return html`
    ${(_a = data == null ? void 0 : data.mobileConfig) == null ? void 0 : _a.columns.map(column => html`
      <adc-column>
            ${column.Links.map(link => {
      var _a2, _b;
      return html`
            <hp-footer-link class="mobile-footer-links content-link" hidden-label-text="${link.newWin ? link.external ? (_a2 = data == null ? void 0 : data.desktopConfig) == null ? void 0 : _a2.newWinTextExternal : (_b = data == null ? void 0 : data.desktopConfig) == null ? void 0 : _b.newWinText : ""}" icon="${link.newWin ? "new-window" : ""}" target="${link.newWin ? "_blank" : "_self"}" href="${link.URL}">
            ${link.Link}
            </hp-footer-link>`;
    })}
      </adc-column>
  `)}
  `;
  }
  displayDesktopNote(data) {
    var _a, _b;
    return html`
      <adc-column col-desktop="10" col-tablet="6">
        <div class="footer-left">
          ${this.renderFootNotes(data)}
        </div>
      </adc-column>
      <adc-column col-desktop="2" col-tablet="2">
        <div class="footer-right">
        ${(_b = (_a = data == null ? void 0 : data.linkData) == null ? void 0 : _a.desktopConfig) == null ? void 0 : _b.socialLinks.map(socialLink => html`
          <a class="social-links" href="${socialLink.href}" target="_blank">
            <img alt="${socialLink.image.alternateText}" src="${socialLink.image.file}">
          </a>
        `)}
        </div>
      </adc-column>
    `;
  }
  displayTabNote(data) {
    var _a, _b;
    return html`
      <adc-column col-desktop="12" col-tablet="12">
        <div class="footer-left">
          ${this.renderFootNotes(data)}
        </div>
        <adc-row class="tab-footer-right">
          <adc-column col-tablet="4">
            <a id="header-one-world-logo"
              href="https://www.aa.com/i18n/travel-info/partner-airlines/oneworld-airline-partners.jsp?from=comp_nav"
              target="_blank">
              <img class="one-world" alt="${TranslationDataController.translations["OneWorld"]}" src="/content/images/icons-logos/logos/logo-oneworld.svg">
            </a>
          </adc-column>
          <adc-column col-tablet="4">
            <div class="footer-right">
              ${(_b = (_a = data == null ? void 0 : data.linkData) == null ? void 0 : _a.desktopConfig) == null ? void 0 : _b.socialLinks.map(socialLink => html`
                  <a class="social-links" href="${socialLink.href}" target="_blank">
                    <img alt="${socialLink.image.alternateText}" src="${socialLink.image.file}">
                  </a>
                `)}
            </div>
          </adc-column>
        </adc-row>
      </adc-column>
    `;
  }
  displayMobileNote(data) {
    this.setupMobileNote(data);
    return html`
    <adc-column col-phone="3">
      <div class="mobile-footer-note">
        ${data == null ? void 0 : data.mobileConfig.NoteLinks.map(noteLink => html`
          <hp-footer-link class="content-link" target="_self" href="${noteLink.URL}">
          ${noteLink.Link}
          </hp-footer-link>
          ${noteLink.showDot ? html`<span aria-hidden="true">&nbsp;&#183;&nbsp;</span>` : html``}
          `)}
      </div>
    </adc-column>

      ${data == null ? void 0 : data.mobileConfig.socialLinks.map(socialLink => html`
        <adc-column col-phone="1" class="one-world-logo">
          <a href="${socialLink.href}" target="_blank">
            <img class="mobile-footer-icon" alt="${socialLink.image.alternateText}" src="${socialLink.image.file}">
          </a>
        </adc-column>`)}
    `;
  }
  renderFootNotes(data) {
    var _a, _b, _c, _d, _e, _f, _g;
    const newWinText = (_b = (_a = data == null ? void 0 : data.linkData) == null ? void 0 : _a.desktopConfig) == null ? void 0 : _b.newWinText;
    const newWinTextExternal = (_d = (_c = data == null ? void 0 : data.linkData) == null ? void 0 : _c.desktopConfig) == null ? void 0 : _d.newWinTextExternal;
    return html`
      ${(_g = (_f = (_e = data == null ? void 0 : data.linkData) == null ? void 0 : _e.desktopConfig) == null ? void 0 : _f.footnote) == null ? void 0 : _g.map(notelink => {
      const key = Object.keys(notelink)[0];
      switch (key) {
        case "multiline":
          return this.renderMultilineNote(notelink.multiline, newWinText, newWinTextExternal);
        case "link":
          return this.renderLinkFootnote(notelink.link, newWinText, newWinTextExternal);
        case "html":
          return this.createHTMLFragment(notelink.html);
        case "text":
          return html`<div>${notelink.text}</div>`;
        case "standard":
          return this.renderStandardNote(notelink.standard);
        default:
          return html``;
      }
    })}`;
  }
  renderMultilineNote(multilineText, newWinText, newWinTextExternal) {
    return html`
      <div>${multilineText == null ? void 0 : multilineText.map(textContent => {
      const key = Object.keys(textContent)[0];
      switch (key) {
        case "text":
          return html`<div>${textContent.text}</div>`;
        case "link":
          return this.renderLinkFootnote(textContent.link, newWinText, newWinTextExternal);
        case "html":
          return this.createHTMLFragment(textContent.html);
        default:
          return html``;
      }
    })}</div><br>`;
  }
  renderStandardNote(standardText) {
    if (standardText && standardText.icon && window.innerWidth < 800) {
      return html`
      <div class="note-link-standard-mobile">
        <div class="note-link-standard-text">
          <hp-footer-icon class="note-link--with-icon note-link" icon="navigation:new-window" size="16"></hp-footer-icon>
          ${standardText == null ? void 0 : standardText.text}
        </div>
      </div>
      <div class="note-link-standard-copyright">
        ${standardText == null ? void 0 : standardText.copyright}
      </div><br>
    `;
    } else if (standardText && standardText.icon) {
      return html`
        <div class="note-link-standard">
          <div>
            <hp-footer-icon class="note-link--with-icon note-link" icon="navigation:new-window" size="16"></hp-footer-icon>
            ${standardText == null ? void 0 : standardText.text} ${standardText == null ? void 0 : standardText.copyright}
          </div>
        </div>
        <br>
      `;
    }
    return html`

      <p>${standardText == null ? void 0 : standardText.text}${standardText == null ? void 0 : standardText.copyright}</p>
    `;
  }
  renderLinkFootnote(content, newWinText, newWinTextExt) {
    return html`<div class="note-link-hyperlink">
            <span class="note-link--hyperlink-description">${content.preLinkText}</span>
                <hp-footer-link class="note-link--hyperlink-text"
                          hidden-label-text="${content.newWin ? content.external ? newWinTextExt : newWinText : ""}"
                          href="${content.href}"
                          target="${content.newWin ? "_blank" : "_self"}"
                          icon="${content.chevron === false || content.newWin ? "" : "chevron"}">
                          ${content.linkText}
                          <hp-footer-icon style="${content.newWin ? "" : "display:none"}" icon="navigation:new-window" size="16"></hp-footer-icon>
                </hp-footer-link>
            ${content.postLinkText}
            </div>`;
  }
  createHTMLFragment(content) {
    return document.createRange().createContextualFragment(content);
  }
  get version() {
    return version;
  }
  setupMobileNote(data) {
    data == null ? void 0 : data.mobileConfig.NoteLinks.forEach((notelink, index) => {
      var _a;
      if (index === ((_a = data == null ? void 0 : data.mobileConfig) == null ? void 0 : _a.NoteLinks.length) - 1) {
        notelink.showDot = false;
      } else {
        notelink.showDot = true;
      }
    });
  }
};
Footer.styles = styles;
__decorateClass([property({
  type: String,
  reflect: true
})], Footer.prototype, "localeCode", 2);
__decorateClass([property({
  type: Number
})], Footer.prototype, "loadTime", 2);
__decorateClass([Log], Footer.prototype, "render", 1);
Footer = __decorateClass([customElement("adc-footer")], Footer);
